import { pathOr } from 'ramda';

export const isServer = typeof window === 'undefined';

export const isClient = !isServer;

export const getUserAgent = () => navigator.userAgent;

export const Android = () => /Android/i.test(getUserAgent()) && !Windows();

export const iPhone = () =>
  /iPhone/i.test(getUserAgent()) && !iPad() && !Windows();

export const iPod = () => /iPod/i.test(getUserAgent());

export const iPad = () => /iPad/i.test(getUserAgent());

export const iOS = () => iPad() || iPod() || iPhone();

export const Windows = () =>
  /Windows Phone|IEMobile|WPDesktop/i.test(getUserAgent());

export const getPlatform = () => {
  if (isServer) return 'unknown';
  if (Android()) return 'android';
  if (iOS()) return 'ios';
  return 'desktop';
};

export const getEnvironment = () =>
  isServer ? process.env : pathOr({}, ['REDUX_STATE', 'environment'], window);

export const gameTypeFromProduct = (product) =>
  product == 'waybetter' ? 'falkor' : product;

export const gameTypeFromTheme = gameTypeFromProduct;

export const isWaybetterProduct = (product) =>
  ['waybetter', 'falkor'].includes(product);

export const themeFromProduct = (product) =>
  product == 'falkor' ? 'waybetter' : product;

export const publicEnvironmentVariables = [
  'ALGOLIA_SEARCH',
  'APPLE_CLIENT_ID',
  'BASE_CONTENTFUL_IMAGE_URL',
  'BRANCH_WAYBETTER_APP_KEY',
  'CLOUDINARY_CLOUD_NAME',
  'DEFAULT_WAYBETTER_OFFER',
  'ERROR_REPORTING_ENABLED',
  'ERROR_REPORTING_HOSTS',
  'ERROR_REPORTING_VIA_CONSOLE',
  'FACEBOOK_CLIENT_ID',
  'GOOGLE_CLIENT_ID',
  'GOOGLE_PAY_MERCHANT_ID',
  'GRAPHQL_INTERNAL_URL',
  'GRAPHQL_URL',
  'QUIZ_CHECKOUT_CHART_PUBLIC_ID',
  'LOG_GRAPHQL_QUERIES',
  'OPTIMIZELY_SDK_KEY',
  'QUIZ_HOST',
  'RECAPTCHA_SITE_KEY',
  'SENTRY_DSN',
  'SHARE_DOMAIN',
  'SUPPORT_EMAIL',
  'TURNSTILE_SITE_KEY',
  'USE_STATIC_CHECKOUT_CHART',
  'WB_AUTH_SERVICE_INTERNAL_BASE_URL',
  'WB_AUTH_SERVICE_BASE_URL',
  'WB_ASSET_ENDPOINT',
  'WB_ASSET_VIDEO_ENDPOINT',
  'WB_ENV',
  'WB_HUB_HOST_FEED_STAFF_USER_IDS',
  'WB_HUB_LOG_LEVEL',
  'WB_WEIGHTLOSS_CHART_BASE_URL',
  'WB_WEIGHTLOSS_CHART_BASE_URL_V2',
  'FF_WBRT_3788_QUIZ_TAKER_SET_ONBOARDING',
  'FF_WBRT_5197_USE_CLOUDFLARE_TURNSTILE',
  'FF_WBRT_5206_RAISE_SERVER_AUTH_ERRORS',
  'FF_WBRT_5206_DEBUG_AUTH_SESSION',
  'FF_WBRT_5455_BRAZE_DONT_TRACK_ANONYMOUS_SESSIONS',
  'FF_WBRT_5465_HUB_REDUCE_ANALYTICS_EVENTS',
  'FF_WBRT_5600_SUPERCHARGER_ENABLE_APPLE_PAY',
  'FF_WBRT_5600_SUPERCHARGER_ENABLE_GOOGLE_PAY',
  'FF_SUPERCHARGER_ENABLE_PROMO_CODE',
];

export const isRecordNotFoundError = (error) =>
  error?.message?.includes('ActiveRecord::RecordNotFound');

export const isIntTooLongError = (error) =>
  error?.message?.includes(
    'Int cannot represent non 32-bit signed integer value'
  );

const {
  GRAPHQL_INTERNAL_URL,
  GRAPHQL_URL,
  WB_AUTH_SERVICE_INTERNAL_BASE_URL,
  WB_AUTH_SERVICE_BASE_URL,
} = getEnvironment();

export const graphQLUrl = isServer ? GRAPHQL_INTERNAL_URL : GRAPHQL_URL;

export const authServiceUrl = isServer
  ? WB_AUTH_SERVICE_INTERNAL_BASE_URL
  : WB_AUTH_SERVICE_BASE_URL;

export const authServiceDomain = (() => {
  try {
    const url = new URL(authServiceUrl);
    return url.hostname;
  } catch (er) {
    console.error(
      'Error parsing auth service cookie domain',
      {
        WB_AUTH_SERVICE_BASE_URL,
        WB_AUTH_SERVICE_INTERNAL_BASE_URL,
      },
      er
    );
  }
})();
